import Store from '@/store';

const isServicesEnabled = () => {
  const companyServicesEnabled = Store.getters['Company/servicesIsEnabled'];
  return !!(companyServicesEnabled);
};

const isShowServicePricesEnabled = () => {
  const companyServicePricesEnabled = Store.getters['Company/servicePricesIsEnabled'];
  return !!(companyServicePricesEnabled);
};

export default {
  isServicesEnabled,
  isShowServicePricesEnabled,
};
